const BASE_API = process.env.REACT_APP_BASE_URL;
import Cookies from 'js-cookie';

export async function fetchErs(slug) {
  const url = `${BASE_API}/ers/${slug}`;
  // Retrieve the access token from localStorage
  const accessToken = Cookies.get("access_token");

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      const { message } = await response.json();
      console.log(message);
      throw new Error(message);
    }

    const data = await response.json();
    
    // Validate that the response contains valid data
    if (data && typeof data.data === 'string' && data.data.includes('<!DOCTYPE html')) {
      // The API returned HTML (likely a CAPTCHA page) instead of JSON data
      throw new Error('API returned HTML instead of JSON data. This might be due to rate limiting or CAPTCHA protection.');
    }
    
    // console.log("data", data);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
